module.exports = __webpack_public_path__ + "img/vasilis.2aa6f2ca.jpeg";